/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Progress_Extra_Calendar_MetaInputs */

const en_us2_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 day trained`);
	return /** @type {LocalizedString} */ (`${i?.days} days trained`)
	
};

const pt_br2_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 dia treinado`);
	return /** @type {LocalizedString} */ (`${i?.days} dias treinados`)
	
};

const es_419_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 día entrenado`);
	return /** @type {LocalizedString} */ (`${i?.days} días entrenados`)
	
};

const pt_pt2_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 dia de treino`);
	return /** @type {LocalizedString} */ (`${i?.days} dias de treino`)
	
};

const fr_fr2_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 0 || i?.days === "0")) return /** @type {LocalizedString} */ (`0 jour d'entraînement`);
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 jour d'entraînement`);
	return /** @type {LocalizedString} */ (`${i?.days} jours d'entraînement`)
	
};

const de_de2_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 Trainingstag`);
	return /** @type {LocalizedString} */ (`${i?.days} Trainingstage`)
	
};

const it_it2_progress_extra_calendar_meta = /** @type {(inputs: Progress_Extra_Calendar_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 giorno di allenamento`);
	return /** @type {LocalizedString} */ (`${i?.days} giorni di allenamento`)
	
};

/**
* | days | output |
* | --- | --- |
* | "1" | "1 day trained" |
* | * | "{days} days trained" |
*
* @param {Progress_Extra_Calendar_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_calendar_meta = /** @type {((inputs: Progress_Extra_Calendar_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Calendar_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_calendar_meta(inputs)
	if (locale === "es-419") return es_419_progress_extra_calendar_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_calendar_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_calendar_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_calendar_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_calendar_meta(inputs)
	return en_us2_progress_extra_calendar_meta(inputs)
});
export { progress_extra_calendar_meta as "progress-extra.calendar_meta" }